import { InputNumber, Select } from 'dash-ui';

import { ICurrencyInputProps } from './CurrencyInput.interfaces';
import { Wrapper } from './CurrencyInput.styles';

const CurrencyInput = ({
  placeholder,
  defaultCurrency,
  defaultValue,
  onInputChange,
  onSelectChange,
  options,
}: ICurrencyInputProps) => (
  <Wrapper>
    <InputNumber
      value={defaultValue}
      h={40}
      w="100%"
      placeholder={placeholder}
      maskOptions={{ prefix: '', allowDecimal: true, decimalLimit: 2 }}
      onChangeValue={(value) => {
        if (onInputChange) {
          onInputChange(value.toString());
        }
      }}
    />
    <Select
      w={154}
      value={defaultCurrency === '' ? undefined : defaultCurrency}
      onChanged={(value) => {
        if (onSelectChange) {
          onSelectChange(value);
        }
      }}
      options={options}
    />
  </Wrapper>
);

export default CurrencyInput;
